import * as THREE from "three";
import { scene } from "./scene";
import { GLTFLoader } from "three/addons/loaders/GLTFLoader.js";
import { ControlFunction } from "./controlFunction";
const loader = new GLTFLoader();
import { progressbar, modelsLoaded } from "./progressbar";

const loadAdamino = () => {
    const promiseAdamino = new Promise((resolve, reject) => {
        loader.load(
            "office/model/adamino/adam-chibi.gltf",
            function (gltf) {
                scene.add(gltf.scene);
                const model = gltf.scene;

                // Posizione iniziale sulla scrivania (da regolare)
                model.position.set(0.5400239730242178, 1.6950426030996868, 4.108749913011099);
                model.scale.set(0.15, 0.15, 0.15);
                model.rotation.set(0, 0.08188507383180457, 0);

                model.traverse(function (object) {
                    if (object.isMesh) {
                        object.castShadow = true;
                        object.receiveShadow = true;
                    }
                });

                // Abilitiamo il ControlFunction per posizionarlo con il mouse
                //ControlFunction(model);

                resolve(model);
                progressbar();
            },
            undefined,
            function (error) {
                console.error(error);
                reject(error);
            }
        );
    });
    return promiseAdamino;
};

export { loadAdamino };
